/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { IObservableArray } from "mobx"
import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { PlanningActionsDtoModel, PlanningActionsDtoModelType } from "./PlanningActionsDtoModel"
import { PlanningActionsDtoModelSelector } from "./PlanningActionsDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  actions: IObservableArray<PlanningActionsDtoModelType>;
}

/**
 * ActivePlanningActionsDtoBase
 * auto generated base class for the model ActivePlanningActionsDtoModel.
 */
export const ActivePlanningActionsDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('ActivePlanningActionsDto')
  .props({
    __typename: types.optional(types.literal("ActivePlanningActionsDto"), "ActivePlanningActionsDto"),
    actions: types.union(types.undefined, types.array(MSTGQLRef(types.late((): any => PlanningActionsDtoModel)))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class ActivePlanningActionsDtoModelSelector extends QueryBuilder {
  actions(builder: string | PlanningActionsDtoModelSelector | ((selector: PlanningActionsDtoModelSelector) => PlanningActionsDtoModelSelector) | undefined) { return this.__child(`actions`, PlanningActionsDtoModelSelector, builder) }
}
export function selectFromActivePlanningActionsDto() {
  return new ActivePlanningActionsDtoModelSelector()
}

export const activePlanningActionsDtoModelPrimitives = selectFromActivePlanningActionsDto()
